export default 'salesPage';
